// Dictionary -
// see also data.js for translated strings related to stats, positions etc.

window.lang = {
    'en': {
        player: 'Player',
        benchmarked_leagues: 'Benchmarked Leagues',
        multiple_leagues: 'Multiple Leagues',
        all_leagues: 'All Leagues',
        all_clubs: 'All Clubs',
        all_nations: 'All Nations',
        comparison_error: 'You can\'t compare a goalkeeper with an outfield player',
        generic_error: 'Sorry, there was an error - please try again',
        find_players_no_results: 'No players matched the filters chosen, please broaden your search and try again',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        password: '**********',
        invalid_password: 'Please choose a password at least 8 characters long which contains a special character (not a number or letter)',
        save_username: 'Are you sure you want to change your email address to %USERNAME%?',
        save_password: 'Are you sure you want to change your password?',
        goalkeeping: 'Goalkeeping',
        confirm_delete_saved_player: 'Are you sure you want to delete %NAME%?',
        confirm_delete_saved_players: 'Are you sure you want to delete these players?',
        confirm_delete_saved_scatter_graph: 'Are you sure you want to delete this scatter graph?',
        confirm_delete_saved_comparison: 'Are you sure you want to delete this comparison?',
        multiple_positions: 'Multiple Positions (%COUNT%)',
    },
    'fr': {
        player: 'Joueur ',
        benchmarked_leagues: 'Benchmarked ligues',
        multiple_leagues: 'Plusieurs ligues',
        all_leagues: 'Toutes les ligues',
        all_clubs: 'Tous les clubs',
        all_nations: 'Toutes les nations',
        comparison_error: 'Vous ne pouvez pas comparer un gardien de but avec un joueur de champ',
        generic_error: 'Désolé, une erreur s\'est produite - veuillez réessayer',
        find_players_no_results: 'Aucun joueur ne correspond aux filtres choisis, veuillez élargir votre recherche et réessayer',
        edit: 'Éditer',
        save: 'Sauvegarder',
        cancel: 'Annuler',
        password: '**********',
        invalid_password: 'Veuillez choisir un mot de passe d\'au moins 8 caractères contenant un caractère spécial (pas un chiffre ou une lettre)',
        save_username: 'Voulez-vous vraiment changer votre adresse e-mail en %USERNAME% ?',
        save_password: 'Êtes-vous sûr de vouloir changer votre mot de passe ?',
        goalkeeping: 'Goal',
        confirm_delete_saved_player: 'Voulez-vous vraiment supprimer %NAME% ?',
        confirm_delete_saved_players: 'Voulez-vous vraiment supprimer ces joueurs ?',
        confirm_delete_saved_scatter_graph: 'Êtes-vous sûr de vouloir supprimer ce graphique de dispersion ?',
        confirm_delete_saved_comparison: 'Voulez-vous vraiment supprimer cette comparaison ?',
        multiple_positions: 'Multiples Positions (%COUNT%)',
    },
    'it': {
        player: 'Giocatore',
        benchmarked_leagues: 'Campionati con Benchmark',
        multiple_leagues: 'più campionati',
        all_leagues: 'Tutte le competizioni',
        all_clubs: 'Tutti i club',
        all_nations: 'Tutte le nazioni',
        comparison_error: 'Non puoi confrontare un portiere con un giocatore di movimento',
        generic_error: 'Mi dispiace, c\'è un errore - riprova',
        find_players_no_results: 'Nessun giocatore corrisponde al filtro scelto, estendi la tua ricerca e riprova',
        edit: 'Modifica',
        save: 'Salva',
        cancel: 'Cancella',
        password: '**********',
        invalid_password: 'Scegli una password che abbia 8 caratteri e che contenga un carattere speciale (non un numero o',
        save_username: 'Sei sicuro di voler cambiare il tuo indirizzo email to %USERNAME%?',
        save_password: 'Sei sicuro di voler cambiare la tua password ?',
        goalkeeping: 'Portiere',
        confirm_delete_saved_player: 'Sei sicuro di voler cancellare %NAME% ?',
        confirm_delete_saved_players: 'Sei sicuro di voler cancellare questi giocatori ?',
        confirm_delete_saved_scatter_graph: 'Sei sicuro di voler cancellare il grafico a dispersione ?',
        confirm_delete_saved_comparison: 'Sei sicuro di voler cancellare il confronto ?',
        multiple_positions: 'Multiple Positions (%COUNT%)',
    },
    'es': {
        player: 'Jugador',
        benchmarked_leagues: 'Ligas con Benchmark',
        multiple_leagues: 'Ligas múltiples',
        all_leagues: 'Todas las ligas',
        all_clubs: 'Todos los clubes',
        all_nations: 'Todas las naciones',
        comparison_error: 'No puedes comparar un portero con un jugador de campo',
        generic_error: 'Lo sentimos, ha habido un errore - Inténtalo de nuevo',
        find_players_no_results: 'Ningún jugador coincidió con los filtros elegidos, amplía tu búsqueda y vuelve a intentarlo',
        edit: 'Modífica',
        save: 'Ahorrar',
        cancel: 'Cancelar',
        password: '**********',
        invalid_password: 'Elige una contraseña de al menos 8 carácteres que contenga un carácter especial (que no sea un número o una letra)',
        save_username: '¿Estás seguro de que quieres cambiar tu dirección de correo electrónico a %USERNAME%?',
        save_password: '¿Estás seguro de que quieres cambiar tu contraseña?',
        goalkeeping: 'Portero',
        confirm_delete_saved_player: 'Está seguro de que desea eliminar %NAME%?',
        confirm_delete_saved_players: 'Estás seguro de que quieres eliminar estos jugadores?',
        confirm_delete_saved_scatter_graph: 'Está seguro de que desea eliminar el diagrama de dispersión?',
        confirm_delete_saved_comparison: 'Está seguro de que desea eliminar la comparación?',
        multiple_positions: 'Múltiples Posiciones (%COUNT%)',
    },
    'de': {
        player: 'Spieler',
        benchmarked_leagues: 'Benchmark-Ligen',
        multiple_leagues: 'Mehrere Ligen',
        all_leagues: 'Alle Ligen',
        all_clubs: 'Alle Vereine',
        all_nations: 'Alle Nationen',
        comparison_error: 'Torwärte können nicht mit Feldspielern verglichen werden',
        generic_error: 'Entschuldigung, es ist ein Fehler aufgetreten - bitte versuchen Sie es erneut',
        find_players_no_results: 'Kein Spieler passt zu den gewählten Filtern, bitte erweitern Sie die Suche und versuchen Sie es erneut',
        edit: 'Bearbeiten',
        save: 'Speichern',
        cancel: 'Stornieren',
        password: '**********',
        invalid_password: 'Bitte wählen Sie ein Passwort, das mindestens 8 Zeichen lang ist und ein Sonderzeichen (keine Zahl oder Buchstaben) enthält',
        save_username: 'Sind Sie sicher, dass Sie Ihre E-Mail-Adresse in %USERNAME% ändern möchten?',
        save_password: 'Sind Sie sicher, dass Sie ihr Passwort ändern möchten?',
        goalkeeping: 'Torwart',
        confirm_delete_saved_player: 'Bist du sicher, dass du %NAME% löschen willst?',
        confirm_delete_saved_players: 'Bist du sicher, dass du diese Spieler löschen willst?',
        confirm_delete_saved_scatter_graph: 'Bist du sicher, dass du dieses Streudiagramm löschen willst?',
        confirm_delete_saved_comparison: 'Bist du sicher, dass du diesen Vergleich löschen willst?',
        multiple_positions: 'mehrere Positionen (%COUNT%)',
    },
    'pt': {
        player: 'Jogador',
        benchmarked_leagues: 'Campeonatos',
        multiple_leagues: 'Mais ligas',
        all_leagues: 'Todas as ligas',
        all_clubs: 'Todos os clubes',
        all_nations: 'Todas as nações',
        comparison_error: 'Você não pode comparar um guarda redes com um jogador de campo',
        generic_error: 'Desculpe, ocorreu um erro - por favor, tente novamente',
        find_players_no_results: 'Nenhum jogador correspondeu aos filtros escolhidos, amplie sua pesquisa e tente novamente',
        edit: 'Modificar',
        save: 'Salve',
        cancel: 'Cancelar',
        password: '**********',
        invalid_password: 'Por favor escolha uma senha com pelo menos 8 caracteres que contenha um caractere especial (não um número ou letra)',
        save_username: 'Tem certeza de que deseja alterar seu endereço de e-mail para% USERNAME%?',
        save_password: 'Tem certeza que deseja alterar sua senha?',
        goalkeeping: 'Guarda redes',
        confirm_delete_saved_player: 'Tem a certeza que quer apagar %NAME%',
        confirm_delete_saved_players: 'Tem a certeza que quer apagar estes jogadores',
        confirm_delete_saved_scatter_graph: 'Tem a certeza que quer apagar o gráfico de dispersão?',
        confirm_delete_saved_comparison: 'Tem a certeza que quer apagar a comparação?',
        multiple_positions: 'Posições variadas (%COUNT%)',
    }
}

// return a string based on the current language, and the given key
window.getLang = function( key, replacements ) {
    let str = lang[config.lang][key];
    if( replacements ) {
        str = str.replace(/%\w+%/g, function(all) {
            return replacements[all] || all;
         });
    }
    return str;
}
